// extracted by mini-css-extract-plugin
export var measureBox = "_bp-0";